export default __webpack_public_path__ + "static/media/prev.223b07a1.svg";